var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:" py-5"},[_c('div',{staticClass:"container"},[_c('transition',{attrs:{"name":"vertical"}},[_c('div',{staticClass:"containerInput"},[_c('InputDados',{attrs:{"background":"#175d93"}})],1)])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }